import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'splittable-text-input-ctrl',
  templateUrl: './splittable-text-input.component.html',
  styleUrls: ['./splittable-text-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SplittableTextInputComponent,
    multi: true
  }]
})
export class SplittableTextInputComponent implements ControlValueAccessor, OnInit  {

  constructor(protected controlContainer: ControlContainer) { }

  @Input() formControlName: string;
  @Input() caption: string;
  @Input() splitterRegex: RegExp;
  @Input() settings: ControlSettings = {};
  defaultSettings: ControlSettings = { fxFill:false, rows:5, scrollable:false };

  displayValue = ''
  splittedItemsCount = 0;

  onChangeFunction: any;
  onTouchedFunction: any;
  isDisabled: boolean;

  ngOnInit(): void {
    Object.assign(this.defaultSettings, this.settings);
    this.settings = this.defaultSettings;
  }

  onInputChange(input: any) {
    const splittedItems = input.toUpperCase().split(this.splitterRegex).map(v => v.trim()).filter(v => v);

    this.splittedItemsCount = splittedItems.length;
    this.displayValue = input;

    if (this.onChangeFunction) {
      this.onChangeFunction(splittedItems);
    }
  }

  onInputBlur() {
    if (this.onTouchedFunction) {
      this.onTouchedFunction();
    }
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFunction = fn;
  }

  registerOnChange(fn: any): void {
     this.onChangeFunction = fn;
  }

  writeValue(obj: any): void {
    this.displayValue = obj.join('\n');
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  formatInput() {
    this.displayValue = this.control.value.join('\n');
  }
}
